module.exports = __webpack_public_path__ + "img/paste.340ebda9.png";